import { isLogin } from "./guard.ts";
import LayourGeneral from "@/layout/general/index.vue";

import LoginNew from "@/views/loginNew/login.vue";
import LoginSubscription from "@/views/loginSubscriptions/login.vue";
import LoginCellphone from "@/views/loginCellphone/loginCellphone.vue";
import LoginCellCode from "@/views/loginCellCode/loginCellCode.vue";
import LoginRegister from "@/views/loginRegister/loginRegister.vue";
import LoginReset from "@/views/loginReset/loginReset.vue";
import LoginAccount from "@/views/loginAccount/loginAccount.vue";
import ResetPassword from "@/views/resetPassword/resetPassword.vue";
import AutoLogin from "@/views/autoLogin/autoLogin";

export default [
  {
    path: "/ingresar/login",
    component: LoginSubscription,
    name: "loginSubscriptions",
  },
  {
    path: "/login",
    name: "auth",
    component: LayourGeneral,
    redirect: { name: "login" },
    children: [
      {
        path: "",
        component: LoginNew,
        name: "login",
        beforeEnter: isLogin,
      },
      {
        path: "/celular/:type?/:value?",
        component: LoginCellphone,
        name: "loginCellphone",
        beforeEnter: isLogin,
      },
      {
        path: "/codigo/:type?",
        component: LoginCellCode,
        name: "loginCellCode",
        beforeEnter: isLogin,
      },
      {
        path: "/codigo/create/:type?",
        component: LoginCellCode,
        name: "createCellCode",
        beforeEnter: isLogin,
      },
      {
        path: "/datos",
        component: LoginRegister,
        name: "loginRegister",
      },
      {
        path: "/recuperar",
        component: LoginReset,
        name: "loginReset",
        beforeEnter: isLogin,
      },
      {
        path: "/cuenta/:cell?/:email?/:code?",
        component: LoginAccount,
        name: "loginAccount",
        beforeEnter: isLogin,
      },
      {
        path: "/",
      },
    ],
  },
  {
    path: "/recuperar/:token/edit",
    component: ResetPassword,
    name: "resetPassword",
  },
  {
    path: "/autologin",
    component: AutoLogin,
    name: "autoLogin",
  },
];
